<template lang="pug">
div.confirm-layout
  div.alert.alert-success
    span 原取藥數量: {{ Math.abs(currentEvent.number1) }}
  
  ConfirmStorage(
    v-if="currentProgress === 'setStorage'"
    :inputLabel="'設定拋棄藥物數量'"
    :defaultAmount="Math.abs(currentEvent.number1)"
    v-on:setNum="getStorage"
  )
</template>

<script>
import ConfirmStorage from '../flowComp/NumberSet';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';

export default {
  name: 'confirmFlow',
  extends: ConfirmFlowBase,
  components: {
    ConfirmStorage,
  },
  props: [],
  data() {
    return {
      storage: 0,
    };
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },
  methods: {
    getStorage(num) {
      this.storage = num;
      if (num > Math.abs(this.currentEvent.number1)) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '拋棄數量不可大於該次取藥數量',
        });
      } else {
        this.recordWasteEvent(this.storage);
      }
    },
    recordWasteEvent(num) {
      const event = {
        event_type: 'WASTE',
        med_record_no: this.currentEvent.med_record_no,
        medication: this.currentEvent.medication.id,
        medication_generic_name: this.currentEvent.medication.generic_name,
        employee: this.$store.state.user.user.id,
        employee_name: `${this.$store.state.user.user.last_name}${this.$store.state.user.user.first_name}`,
        // device: this.currentDrugInDevice.device.id,
        // stock: this.currentEvent.child_medication_quantity,
        // total_stock: this.currentMed.child_medication_quantity,
        batch_no: this.currentEvent.batch_no,
        number1: num,
        checked: true,
      };
      this.instance.post('/api/event/', event)
      .then((res) => {
        const recordedEventId = res.data;
        this.instance.patch(`/api/event/${this.currentEvent.id}/`, {
          checked: true,
          related_events: [recordedEventId],
        })
        .then(() => {
          this.$emit('confirmationFinish');
        });
      });
    },
  },
  computed: {
  },
  watch: {
    currentEvent(val) {
      if (this.startType === 'event') {
        this.medRecordId = this.currentEvent.med_record_no;
        this.patchNo = this.currentEvent.batch_no;
        this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?0ccd602e